const sessionState = {
  active: false,
  currentStepIndex: -1,
  advancingStep: false,
  promptScheduled: false,
  awaitingPromptAfterReset: false,
};

export function isTutorialActive() {
  return sessionState.active;
}

export function setTutorialActive(active) {
  sessionState.active = Boolean(active);
}

export function getCurrentStepIndex() {
  return sessionState.currentStepIndex;
}

export function setCurrentStepIndex(index) {
  sessionState.currentStepIndex = index;
}

export function incrementStepIndex() {
  sessionState.currentStepIndex += 1;
  return sessionState.currentStepIndex;
}

export function isAdvancingStep() {
  return sessionState.advancingStep;
}

export function setAdvancingStep(isAdvancing) {
  sessionState.advancingStep = Boolean(isAdvancing);
}

export function isPromptScheduled() {
  return sessionState.promptScheduled;
}

export function setPromptScheduled(scheduled) {
  sessionState.promptScheduled = Boolean(scheduled);
}

export function isAwaitingPromptAfterReset() {
  return sessionState.awaitingPromptAfterReset;
}

export function setAwaitingPromptAfterReset(awaiting) {
  sessionState.awaitingPromptAfterReset = Boolean(awaiting);
}

export function resetSessionState() {
  sessionState.active = false;
  sessionState.currentStepIndex = -1;
  sessionState.advancingStep = false;
  sessionState.promptScheduled = false;
  sessionState.awaitingPromptAfterReset = false;
}
